import React from 'react';

import { range } from 'lodash';

import Button from '../Button';

export type PaginationProps = {
  currentPage: number;
  pageCount: number;
  onPaginate: (page: number) => void;
  label?: string;
};

function Pagination({ currentPage, pageCount, onPaginate, label = 'pagination' }: PaginationProps) {
  const buttons = range(1, pageCount + 1).map((page) => (
    <Button
      key={page}
      type="bare"
      className={page === currentPage ? 'active' : ''}
      onClick={() => {
        if (page !== currentPage) {
          onPaginate(page);
        }
      }}
    >
      {page}
    </Button>
  ));

  return (
    <nav aria-label={label} className="pagination">
      <span>Page: </span>
      {buttons}
    </nav>
  );
}

export default Pagination;
